var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoresultsFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    enableBackground: "new 0 0 32 32",
    id: "_x3C_Layer_x3E_",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "page_x2C__document_x2C__emoji_x2C__No_results_x2C__empty_page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1521_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5,14.75c0.41,0,0.75,0.34,0.75,0.75s-0.34,0.75-0.75,0.75s-0.75-0.34-0.75-0.75    S21.09,14.75,21.5,14.75z",
    fill: "#263238",
    id: "XMLID_1887_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,14.75c0.41,0,0.75,0.34,0.75,0.75s-0.34,0.75-0.75,0.75s-0.75-0.34-0.75-0.75    S10.09,14.75,10.5,14.75z",
    fill: "#263238",
    id: "XMLID_1885_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1337_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4010_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4073_",
    points: "     21.5,1.5 4.5,1.5 4.5,30.5 27.5,30.5 27.5,7.5    ",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4072_",
    points: "     21.5,1.5 27.479,7.5 21.5,7.5 21.5,4    ",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M14.5,18.5c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5",
    fill: "none",
    id: "XMLID_4071_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4068_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "      M20.75,15.5c0,0.41,0.34,0.75,0.75,0.75s0.75-0.34,0.75-0.75s-0.34-0.75-0.75-0.75S20.75,15.09,20.75,15.5z",
    fill: "none",
    id: "XMLID_4070_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M11.25,15.5c0,0.41-0.34,0.75-0.75,0.75s-0.75-0.34-0.75-0.75s0.34-0.75,0.75-0.75S11.25,15.09,11.25,15.5z",
    fill: "none",
    id: "XMLID_4069_",
    stroke: "#455A64",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2974_"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4009_",
    points: "     21.5,1.5 4.5,1.5 4.5,30.5 27.5,30.5 27.5,7.5    ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    id: "XMLID_4008_",
    points: "     21.5,1.5 27.479,7.5 21.5,7.5 21.5,4    ",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "     M14.5,18.5c0-0.83,0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5",
    fill: "none",
    id: "XMLID_4007_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4004_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "      M20.75,15.5c0,0.41,0.34,0.75,0.75,0.75s0.75-0.34,0.75-0.75s-0.34-0.75-0.75-0.75S20.75,15.09,20.75,15.5z",
    fill: "none",
    id: "XMLID_4006_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "      M11.25,15.5c0,0.41-0.34,0.75-0.75,0.75s-0.75-0.34-0.75-0.75s0.34-0.75,0.75-0.75S11.25,15.09,11.25,15.5z",
    fill: "none",
    id: "XMLID_4005_",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoresultsFound);
export default __webpack_public_path__ + "static/media/NoresultsFound.51e5643d6834ebdb6cd3fefe897d94e4.svg";
export { ForwardRef as ReactComponent };